import { GlobalMessageInterface } from 'reducers/globalMessages';

export function fadeMessage(id: string, messages: GlobalMessageInterface[]) {
    return messages.map(message => (message.id === id ? { ...message, fade: true } : message));
}

export function clearMessage(id: string, messages: GlobalMessageInterface[]) {
    return messages.filter(message => message.id !== id);
}
